import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { device, priceFormatted } from '../../../utils/helpers'
import CaretIcon from '../../UI/Icons/CaretIcon'
import Modal from 'react-modal'
import ConfirmPopup from '../../UI/Modals/ConfirmPopup'
import ComponentItem from './Component'
import { withRouter } from 'react-router'

const Wrapper = styled.div`
  background-color: #f3f3f3;
  border-bottom: 1px solid #ccc;
  padding: 12px 20px;
  cursor: pointer;

  @media ${device.tablet} {
    ${''/* padding: 18px 28px; */}
    padding: 0.9375vw 1.4583333333333335vw;
  }
`

const InnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => props.collapsed ? 'center' : 'initial'};
`

const Number = styled.div`
  border: 3px solid ${props => props.visited ? '#4d4d4d' : '#ccc'};
  border-color: ${props => props.active && '#fca317'};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 37px;
  height: 37px;
  font-size: 16px;
  color: ${props => props.active || props.visited ? '#4d4d4d' : '#ccc'};
  font-family: 'BarlowExtraBold';

  @media ${device.tablet} {
    ${''/* font-size: 30px; */}
    font-size: 1.5625vw;
    ${'' /* width: 46px;
    height: 46px; */}
    width: 2.604166666666667vw;
    height: 2.604166666666667vw;
  }

  @media ${device.laptop} {
    border-width: 5px;
  }
`

const Name = styled.div`
  ${''/* padding-left: 24px; */}
  padding-left: 1.25vw;
`

const ComponentName = styled.div`
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  ${props => props.active || props.visited ? '#4d4d4d' : '#ccc'};
  font-size: 16px;

  @media ${device.tablet} {
    font-size: 1.25vw;
  }
`

const Subtitle = styled.p`
  font-size: 16px;
  font-family: 'BarlowSemiBold';
  color: #999999;
  text-transform: uppercase;

  @media ${device.tablet} {
    font-size: 1.09375vw;
  }
`

const Price = styled.div`
  margin-left: auto;
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  ${props => props.active ? '#fca317' : '#4d4d4d'};
  font-size: 16px;

  @media ${device.tablet} {
    font-size: 1.25vw;
  }
`

const ComponentList = styled.div`
  display: flex;
  flex-direction: column;
`

const Caret = styled(CaretIcon)`
  width: 7px;

  @media ${device.tablet} {
    width: 0.36458333333333337vw;
  }
`

let Section = class Section extends Component {
  state = {
    modalOpen: false
  }

  handleNavigation (path, e) {
    e.stopPropagation()
    let currentUrl = window.location.pathname.split('/')
    let currentIndex = currentUrl[currentUrl.length - 1]
    const { visited, index, active } = this.props
    if (parseInt(currentIndex) === 3 || parseInt(currentIndex) === 4) {
      if (visited && parseInt(currentIndex) !== parseInt(index)) {
        this.setState({ modalOpen: true })
      }
    } else {
      if (visited) {
        this.props.history.push(path)
      }
    }
    // if (active && visited && path) {
    //   if (index === 3 || index === 4) {
    //     this.props.history.push(path)
    //   } else {
    //     this.setState({ modalOpen: true })
    //   }
    // }
  }

  closeStepModal (e) {
    this.setState({ modalOpen: false })
  }

  handleConfirmClick () {
    const { path } = this.props
    this.props.history.push(path)
  }

  render () {
    let {
      index,
      name,
      active,
      visited,
      price,
      components,
      selectedComponent,
      coefficient,
      collapsed,
      path
    } = this.props
    if (components) {
      components = components.filter(component => component.selected)
    }
    return (
      <Fragment>
        <Wrapper onClick={this.handleNavigation.bind(this, path)}>
          <InnerWrapper collapsed={collapsed}>
            {/* Number of the step */}
            <Number active={active} visited={visited}>
              {index}
            </Number>
            {/* Name of the step */}
            {name && <Name>
              <ComponentName>
                {name}
              </ComponentName>
              {/* If the step is visited and index is not of Logistica
                * then show the subtitle
                * If the step has components and is not active,
                * then show "DETTAGLI" else show the selected component
              */}
              {visited && index !== 5 && <Subtitle>{components && !active
                ? <React.Fragment>
                  <Caret fill='#999999' /> DETTAGLI
                </React.Fragment>
                : selectedComponent}</Subtitle>}
            </Name>}

            {/* Show price only if visited and price exists */}
            {(visited && price) ? <Price>
              + {priceFormatted(price)}
            </Price> : ''}
          </InnerWrapper>

          {/* List out components only if active and components exists */}
          {components && active && <ComponentList>
            {components.map(({ name, price, details }, index) => (
              <ComponentItem
                name={name}
                price={Math.round(price + (price * coefficient))}
                details={details}
                key={index}
              />
            ))}
          </ComponentList>}
        </Wrapper>
        {/* Step Change confirmation */}
        <Modal
          isOpen={this.state.modalOpen}
          className='Modal2'
          overlayClassName='Overlay2'
        >
          <ConfirmPopup
            title='SEI SICURO DI VOLER CAMBIARE STEP?'
            closeModal={this.closeStepModal.bind(this)}
            confirm={this.handleConfirmClick.bind(this)}
          />
        </Modal>
      </Fragment>
    )
  }
}

function mapStateToProps (state) {
  return {
    coefficient: state.calculator.coefficient,
    average: state.calculator.average
  }
}

Section = withRouter(Section)

export default connect(mapStateToProps)(Section)



// WEBPACK FOOTER //
// ./src/components/Calculator/Sidebar/Step.js